<template>
	<div class="date-picker-view">
		<div v-show="view == 'dates'" class="dates">
			<div class="header">
				<div class="month">{{ state.year }}</div>
				<div class="prev" @click="setStateYearRel(-1)">&lt;</div>
				<div class="next" @click="setStateYearRel(1)">&gt;</div>
			</div>
			<div class="body">
				<div class="month" @click="setMonth(1)" :class="{ today: isToday(1), selection: isSelection(1) }">JAN</div>
				<div class="month" @click="setMonth(2)" :class="{ today: isToday(2), selection: isSelection(2) }">FEB</div>
				<div class="month" @click="setMonth(3)" :class="{ today: isToday(3), selection: isSelection(3) }">MAR</div>
				<div class="month" @click="setMonth(4)" :class="{ today: isToday(4), selection: isSelection(4) }">APR</div>

				<div class="month" @click="setMonth(5)" :class="{ today: isToday(5), selection: isSelection(5) }">MAJ</div>
				<div class="month" @click="setMonth(6)" :class="{ today: isToday(6), selection: isSelection(6) }">JUN</div>
				<div class="month" @click="setMonth(7)" :class="{ today: isToday(7), selection: isSelection(7) }">JUL</div>
				<div class="month" @click="setMonth(8)" :class="{ today: isToday(8), selection: isSelection(8) }">AUG</div>

				<div class="month" @click="setMonth(9)" :class="{ today: isToday(9), selection: isSelection(9) }">SEP</div>
				<div class="month" @click="setMonth(10)" :class="{ today: isToday(10), selection: isSelection(10) }">OKT</div>
				<div class="month" @click="setMonth(11)" :class="{ today: isToday(11), selection: isSelection(11) }">NOV</div>
				<div class="month" @click="setMonth(12)" :class="{ today: isToday(12), selection: isSelection(12) }">DEC</div>
			</div>
		</div>
		<div v-show="view == 'months'" class="months">
			months
		</div>
		<div v-show="view == 'years'" class="years">
			years
		</div>
	</div>
</template>

<script>
	import WeekNumberMixin from '../../mixins/WeekNumberMixin'
	import CompareDatesMixin from '../../mixins/CompareDatesMixin'

	export default {
		mixins: [
			WeekNumberMixin,
			CompareDatesMixin
		],
		data: function () {
			return {
				state: {
					year: null,
					month: null,
					date: null
				},
				view: 'dates',
				weekDays: {
					sun: 0,
					mon: 1,
					tue: 2,
					wed: 3,
					thu: 4,
					fri: 5,
					sat: 6
				}
			};
		},
		props: {
			value: {
				type: String,
				default: (new Date()).format('Y-m-d')
			},
			status: Array,
			months: {
				type: Array,
				default: function () {
					return ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
				}
			},
			days: {
				type: Array,
				default: function () {
					return ['S', 'M', 'T', 'O', 'T', 'F', 'L'];
				}
			},
			weekend: {
				type: Array,
				default: function () {
					return ['sat', 'sun'];
				}
			},
			firstDayOfWeek: {
				type: String,
				default: 'mon'
			},
			showWeeks: {
				type: Boolean,
				default: true
			}
		},
		watch: {
			/*state(newVal, oldVal) {
				
			},*/
			value() {
				this.resetState();
			}
		},
		computed: {
			date() {
				return new Date(this.value);
			},
			today() {
				return new Date();
			},
			selection() {
				return new Date(this.state.year, this.state.month - 1, this.state.date);
			},
			daysCorrected() {
				var r = [];

				for (var i = 0; i < 7; ++i) {
					r.push(this.days[(i + this.weekDays[this.firstDayOfWeek]) % 7]);
				}

				return r;
			},
			statusCorrected() {
				var r = [];
				var status;

				for (var i in this.status) {
					status = this.status[i];
					status.date = new Date(status.date);
					r.push(status);
				}

				return r;
			},
			rows() {
				var i = 0;
				var r = [];
				var week = [];
				var date = new Date(this.state.year, this.state.month - 1, 1);

				while (date.getDay() != this.weekDays[this.firstDayOfWeek]) {
					date.setDate(date.getDate() - 1);
				}

				var endDate = new Date(this.state.year, this.state.month - 1, 1);
				endDate.setMonth(endDate.getMonth() + 1);
				endDate.setDate(endDate.getDate() - 1);

				while (endDate.getDay() != ((this.weekDays[this.firstDayOfWeek] + 6) % 7)) {
					endDate.setDate(endDate.getDate() + 1);
				}

				while (date <= endDate) {
					//

					week.push({
						date: this.getFormattedDate(date, 'Y-m-d'),
						label: date.getDate(),
						today: this.compareDates(this.today, date) == 0,
						selection: this.compareDates(this.date, date) == 0,
						prev: this.compareMonths(date, this.selection) == -1,
						next: this.compareMonths(date, this.selection) == 1,
						status: this.getStatus(date)
					});

					if (++i % 7 == 0) {
						r.push({
							week: this.getWeekNumber(date),
							days: week
						});

						week = [];
					}

					date.setDate(date.getDate() + 1);
				}

				return r;
			}
		},
		methods: {
			isSelection(month) {
				var m = new Date(this.state.year, month - 1, 1);
				var sel = new Date(this.value);

				return m.format('Y-m') == sel.format('Y-m');
			},
			isToday(month) {
				var m = new Date(this.state.year, month - 1, 1);
				var today = new Date();

				return m.format('Y-m') == today.format('Y-m');
			},
			setDate(date) {
				this.$emit('input', date);
			},
			setMonth(month) {
				//this.state.year = year;
				//this.state.month = month;
				var d = new Date(this.state.year, month - 1, 1);

				this.$emit('input', d.format('Y-m-d'));
			},
			getStatus(date) {
				var d = new Date(date);

				for (var i in this.status) {
					if (this.compareDates(this.statusCorrected[i].date, d) == 0) {
						return this.statusCorrected[i];
					}
				}

				return null;
			},
			setState(date) {
				this.state.year = date.getFullYear();
				this.state.month = date.getMonth() + 1;
				this.state.date = date.getDate();

				this.$emit('browse', this.state.year, this.state.month);
			},
			resetState() {
				this.setState(this.date);
			},
			setStateMonth(year, month) {
				this.state.year = year;
				this.state.month = month;

				this.$emit('browse', this.state.year, this.state.month);
			},
			setStateYear(year) {
				this.state.year = year;

				this.$emit('browse', this.state.year, this.state.month);
			},
			setStateMonthRel(bias) {
				var d = new Date(this.state.year, this.state.month - 1, this.state.date);
				d.setMonth(d.getMonth() + bias);
				this.setState(d);
			},
			setStateYearRel(bias) {
				var d = new Date(this.state.year, this.state.month - 1, this.state.date);
				d.setFullYear(d.getFullYear() + bias);
				this.setState(d);
			}
		},
		mounted() {
			this.resetState();
		},
		created() {
			this.resetState();
		}
	}
</script>

<style lang="scss" scoped>
	.date-picker-view {
		padding: 15px 15px 15px 20px;

		& > .dates {
			display: grid;
			grid-template-columns: 1fr;
			grid-template-rows: 30px 1fr;

			& > .header {
				display: grid;
				grid-template-columns: 1fr 30px 30px;
				grid-template-rows: 1fr;

				& > .month, & > .prev, & > .next {
					line-height: 30px;
					cursor: pointer;
				}

				& > .month {
					text-transform: capitalize;
					font-size: 16px;
				}

				& > .prev, & > .next {
					text-align: center;
				}
			}

			& > .body {
				margin-top: 20px;
				display: grid;
				grid-row-gap: 4px;
				grid-template-columns: 1fr 1fr 1fr 1fr;

				& > .month {
					line-height: 40px;
					text-align: center;
					font-size: 12px;
					cursor: pointer;
					border-radius: 5px;

					&.today {
						border: 1px solid #f7223f;
						line-height: 38px;
					}

					&.selection {
						background-color: #f7223f;
						color: white;
					}
				}

				& > .days, & > .week {
					display: grid;
					grid-template-columns: repeat(8, 1fr);
					grid-template-rows: auto;
					justify-items: center;

					& > div {
						line-height: 30px;
						text-align: center;
						font-size: 12px;
						width: 30px;
					}
				}

				& > .days > div {
					color: #a7a7a7;

					&.weekend {
						color: red;
					}
				}

				& > .week {
					& > .week {
						text-align: left;
						color: #a7a7a7;
					}

					& > .date {
						border: 1px solid #00000000;
						line-height: 28px;
						border-radius: 50%;
						position: relative;
						cursor: pointer;
						/*transition: background-color .25s, color .25s, border-color .25s;*/

						&.prev, &.next {
							color: #a7a7a7;
						}

						&.today {
							border: 1px solid #f7223f;
							line-height: 28px;
						}

						&.selection {
							background-color: #f7223f;
							color: white;
						}

						& > .notification {
							position: absolute;
							right: -1px;
							right: -1px;
							top: -1px;
							width: 10px;
							height: 10px;
							border: 2px solid #F0F0F0;
							background-color: #f7223f;
							border-radius: 50%;

							&.yellow {
								background-color: #ffcf00;
							}

							&.gray {
								background-color: #a3a3a3;
							}

							&.red {
								background-color: #f7223f;
							}

							&.green {
								background-color: #00c017;
							}
						}
					}
				}
			}
		}
	}

	.notification-enter-active, .notification-leave-active {
		transition: opacity .25s, transform .25s;
		/*transform: scale(0);*/
	}

	.notification-enter, .notification-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
		/*transform: scale(1);*/
	}
</style>